import EdverumTable from '@/store/utilities/EdverumTable.js';

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.created.state,
        ...EdverumTable.searchTag.state,
    },
    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
    },
    actions: {
        ...EdverumTable.created.actions,
        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags('/api/tags?type=notes'),
        fetchAllTags: EdverumTable.searchTag.actions.fetchAllTags('/api/tags?permissions=true'),
    },
    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.created.mutations,
        ...EdverumTable.searchTag.mutations,
    },
};
